export default __webpack_public_path__ + "static/media/background-sidebar.052f1349.jpg";